module.exports = {
      id: "filter-usage",
      viewBox: "0 0 8 8",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#filter",
      toString: function () {
        return this.url;
      }
    }